import { sagaEffects } from '../../dependencies';

import updateTags from './updateTags';

const { all } = sagaEffects;

export default function*() {
    yield all([updateTags()]);
}
